/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Error_Session_ExpiredInputs */



/**
* | output |
* | --- |
* | "Session expired. Please request a new link." |
*
* @param {Auth_Verify_Error_Session_ExpiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_error_session_expired = /** @type {((inputs?: Auth_Verify_Error_Session_ExpiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Error_Session_ExpiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Session expirée. Veuillez demander un nouveau lien.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sesión expirada. Por favor, solicite un nuevo enlace.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sessão expirada. Por favor, solicite um novo link.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sessione scaduta. Richiedi un nuovo link.")
	return /** @type {LocalizedString} */ ("Session expired. Please request a new link.")
});